import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateMeetingPayload } from '@app-store/slices/meetings/createMeeting'
// import { history } from '@components/App'
// import routes from '@utils/constants/routes'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ICreateMeetingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.create

function* createMeetingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/meeting`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (response?.result?._id) {
                // history.push(routes.meetings.meeting_agenda.profile._.replace(':id', response?.result?._id))
                if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
                notification.success({
                    message: 'Meeting created successfully.'
                })
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createMeetingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createMeetingSagaTask)
}

export default createMeetingSaga
